import * as z from 'zod';
/**
 * Capabilities that can be switched off without a release.
 *
 * SPEC.md §51 asked for flags around risky functionality. They are defined here
 * rather than as loose strings so that a typo fails to compile and so that both
 * applications and the backend agree on the vocabulary.
 *
 * Flags gate *risk*. Entitlements gate *subscription*. A capability can be
 * flagged on and still be unavailable because the family has not paid for it.
 */
export const featureFlagKeySchema = z.enum([
    'ACTIVE_VIEWING',
    'DISTANCE_DETECTION',
    'POSE_BREAKS',
    'WEB_GAMES',
    'YOUTUBE',
    'YOUTUBE_CHANNEL_SYNC',
    'IPTV',
]);
/**
 * Subscription capabilities.
 *
 * Resolved server-side. SPEC.md §39 requires that tier checks never be
 * scattered through the interface, so clients receive resolved entitlements
 * and never reason about tiers themselves.
 */
export const entitlementKeySchema = z.enum([
    'ACTIVE_VIEWING',
    'IPTV',
    'ADVANCED_RULES',
    'MULTI_DEVICE',
    'MULTI_CHILD',
]);
//# sourceMappingURL=feature-flag.js.map